
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.jQuery = require('jquery');
window.$ = require('jquery');
const jQueryBridget = require('jquery-bridget');
window.Cookies = require('js-cookie');
require('bootstrap');
window.notify = require('bootstrap4-notify');
const Isotope = require('isotope-layout');
// make Isotope a jQuery plugin
jQueryBridget( 'isotope', Isotope, $ );
require('jquery-blockui');
window.downloadjs = require('downloadjs');

/* Old plugins and old app configuration */
require('datatables.net');
require('datatables.net-bs4');
require('datatables.net-dt');
require('datatables.net-responsive');
require('datatables.net-responsive-bs4');
require('datatables.net-responsive-dt');
require('datatables.net-scroller');
require('datatables.net-scroller-bs4');
require('datatables.net-scroller-dt');

require('chart.js');

/* /Old plugins and old app configuration */

require('../../../vendor/canela/canelatools/resources/js/canelatools');

window.Vue = require('vue');
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

window.axios = require('axios').default;
var Promise = require('es6-promise-promise');

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);


const Entities = require('html-entities').AllHtmlEntities;

window.entities = new Entities();